import { render } from "./IDTagPaymentForm.vue?vue&type=template&id=6bcd41b4&scoped=true"
import script from "./IDTagPaymentForm.vue?vue&type=script&lang=js"
export * from "./IDTagPaymentForm.vue?vue&type=script&lang=js"

import "./IDTagPaymentForm.vue?vue&type=style&index=0&id=6bcd41b4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/corpsales-services/corpsales-services/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcd41b4"]])

export default __exports__